import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'yporroi';
const args = {};

export class Yporroi extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
